export default __webpack_public_path__ + "static/media/icons8-portrait_mode_scanning.644d80d4.svg";